module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI0ZGRiIgZD0ibTE2LjA2NyAxMy41MzkgNi44NTYgNi44ODRMMjAuMzU3IDIzIDEzLjUgMTYuMTE2IDYuNjQzIDIzbC0yLjU2Ny0yLjU3NyA2Ljg1Ni02Ljg4NEw0IDYuNTc4IDYuNTY3IDRsNi45MzMgNi45NjFMMjAuNDMzIDQgMjMgNi41NzdsLTYuOTMzIDYuOTYxeiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/mb-close.svg
// module id = jxAm
// module chunks = 41